import { createGlobalStyle } from 'styled-components'

import { FONT_FAMILIES } from '../designSystem'
import { Colors } from '../styling'

export const GlobalStyles = createGlobalStyle`
  /* reset template */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1.2;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* reset end */

  html {
    font-size: 16px; /* = 1rem */
  }

  body,
  input,
  textarea,
  select,
  button {
    margin: 0;
    padding: 0;
    font-family: ${FONT_FAMILIES.primary};
    font-size: 1rem;
  }
  body {
    background-color: ${Colors.appBg};
    color: ${Colors.white.main};
    background-size: cover;

    @media print {
      color: ${Colors.black.pure};
      background: ${Colors.white.pure};
    }
  }

  input {
    padding: 0.5rem;
    border: 1px solid #95989a;
    border-radius: 0.25rem;
  }

  /* react-grid disabling animation */
  .react-grid-item {
    transition: all 0s;
  }

  /* apply a natural box layout model to all elements, but allowing components to change */
  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`
